import React from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';

// GLOBAL COMPONENTS
import Card from 'parts/card/Card';

// LOCAL COMPONENTS
import TradeView from '../../tools/TradeView';

export default function Trade() {
  const { values: { aryTrade = [] } = {} } = useFormikContext() || {};

  return !!aryTrade.length && <Card title="Trade Info" body={<TradeView data={aryTrade} />} />;
}
